<template>
  <div class="main_table_wrap">
    <!-- 已经选中的行程的列表 -->
    <div class="trip_line">
      <span class="trip_box" v-for="(item, i) in tabs" :key="i">
        <span class="trip_span trip_checked" v-if="i + 1 == currentIndex">
          <span class="trip_number">{{ i + 1 }}</span>
          {{ item.orgCityName }}
          <img class="arrow_icon" src="~@/assets/img/arrow_icon2.png" />
          {{ item.dstCityName }}
        </span>

        <span
          class="trip_span"
          v-if="i + 1 < currentIndex"
          @click="dropTicket(i)"
        >
          <span class="trip_number">{{ i + 1 }}</span>
          {{ item.orgCityName }}
          <img class="arrow_icon" src="~@/assets/img/arrow_icon1.png" />
          {{ item.dstCityName }}
        </span>
        <span class="trip_span" v-if="i + 1 > currentIndex">
          <span class="trip_number">{{ i + 1 }}</span>
          选择第{{ getNext(i) }}程
        </span>
      </span>
    </div>
    <!-- 加载数据：小飞机进度滑动动态 -->
    <div class="bar_progress" v-show="isShowProgress">
      <div class="flight_process_bar" :style="progress">
        <p>查询到{{ cntNum }}个航班</p>
        <div class="flight_icon"></div>
      </div>
    </div>
    <!-- 推荐组合航班表格头部 -->
    <template v-if="getTabName == 'first'">
      <div class="f_table_title clearfix">
        <div class="title first">航班</div>
        <div class="title second">起飞时间</div>
        <div class="title third">s</div>
        <div class="title forth">到达时间</div>
        <div class="title five">往返总价差</div>
        <div class="title six">s</div>
      </div>
    </template>
    <!-- 自由组合航班表格头部 -->
    <template v-else>
      <div class="f_table_title clearfix">
        <div class="title first">航班</div>
        <!-- 起飞时间 -->
        <div class="title second cursor_pointer" @click="sort('depart')">
          <span class="text">起飞时间</span>
          <span v-if="sortName.type == 'depart'" class="sort_icon">
            <img
              v-if="sortName.sort == 'default'"
              src="~@/assets/img/sort_default_icon.png"
              alt=""
            />
            <img
              src="~@/assets/img/sort_asc_icon.png"
              alt=""
              v-if="sortName.sort == 'asc'"
            />
            <img
              src="~@/assets/img/sort_desc_icon.png"
              alt=""
              v-if="sortName.sort == 'desc'"
            />
          </span>
          <span v-else class="sort_icon">
            <img src="~@/assets/img/sort_default_icon.png" alt="" />
          </span>
        </div>
        <div class="title third">s</div>
        <!-- 到达时间 -->
        <div class="title forth cursor_pointer" @click="sort('arrival')">
          <span class="text">到达时间</span>

          <span v-if="sortName.type == 'arrival'" class="sort_icon">
            <img
              src="~@/assets/img/sort_default_icon.png"
              v-if="sortName.sort == 'default'"
            />
            <img
              src="~@/assets/img/sort_asc_icon.png"
              v-if="sortName.sort == 'asc'"
            />
            <img
              src="~@/assets/img/sort_desc_icon.png"
              v-if="sortName.sort == 'desc'"
            />
          </span>
          <span v-else class="sort_icon">
            <img src="~@/assets/img/sort_default_icon.png" />
          </span>
        </div>
        <!-- 往返总价差 -->
        <div @click="sort('priceAdult')" class="title five cursor_pointer">
          往返总价差
          <span v-if="sortName.type == 'priceAdult'" class="sort_icon">
            <img
              src="~@/assets/img/sort_default_icon.png"
              v-if="sortName.sort == 'default'"
            />
            <img
              src="~@/assets/img/sort_asc_icon.png"
              v-if="sortName.sort == 'asc'"
            />
            <img
              src="~@/assets/img/sort_desc_icon.png"
              v-if="sortName.sort == 'desc'"
            />
          </span>
          <span v-else class="sort_icon">
            <img src="~@/assets/img/sort_default_icon.png" />
          </span>
        </div>
        <div class="title six"></div>
      </div>
    </template>
    <flightList />
  </div>
</template>

<script >
import flightList from "./flightList.vue";
import flightTicket from "../../utils/flightTickets";
import utils from "../../utils/utils";
export default {
  name: "selectedm",
  data() {
    let timeOut = null;
    return {
      progress: `width:20%`,
      progressObj: timeOut,
      num: 20,
    };
  },
  props: {
    closeDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    flightList,
  },

  methods: {
    dropTicket(index) {
      let obj = new flightTicket();
      obj.dropTickets(index, this.$store);
    },
    getNext: function (index) {
      return utils.getNumber(index + 1);
    },
    sort: function (type) {
      let currentSort = this.$store.getters.getSort;
      currentSort.type = type;
      if (currentSort.sort == "default" || currentSort.sort == "desc") {
        currentSort.sort = "asc";
      } else {
        currentSort.sort = "desc";
      }
    },
    getTickets: function () {},

    processAdd: function () {
      let numNow = this.num;
      this.progressObj = setInterval(() => {
        numNow += 1;
        if (numNow >= 100) {
          numNow = 20;
        }
        this.progress = `width:${numNow}%`;
      }, 1000);
    },
  },
  watch: {
    //父组件关闭了模态框，就清除定时器
    closeDialog(newVal, oldVal) {
      // debugger
      clearInterval(this.progressObj);
      this.$store.commit("setDialogVisible", false);
    },
    //数据加载完成后让小飞机进度条100%，后关闭小飞机进度条
    "$store.getters.getProgressSuccess"(newVal, oldVal) {
      if (newVal) {
        this.progress = `width:100%`;
        clearInterval(this.progressObj);
        setTimeout(() => {
          this.$store.commit("setShowProgress", false);
        }, 1500);
      }
    },
  },
  computed: {
    tabs() {
      let rxjsMsg = this.$store.getters.getRxjsMsg;
      let tabName = this.$store.getters.getTabName;
      let flightSegList = rxjsMsg.parameter.groupTickets.flightSegList;
      return flightSegList;
    },

    sortName() {
      let currentSort = this.$store.getters.getSort;
      return currentSort;
    },

    currentIndex() {
      return this.$store.getters.getCurrentIndex;
    },
    cntNum() {
      let listNum = this.$store.getters.getlistNum;
      return listNum;
    },
    getTabName() {
      return this.$store.getters.getTabName;
    },
    // isShowProgress() {
    //   return this.$store.getters.getShowProgress;
    // }
    isShowProgress() {
      let tabName = this.$store.getters.getTabName;
      let isShow = this.$store.getters.getShowProgress;
      if (tabName == "second" && isShow) {
        this.processAdd();
        return this.$store.getters.getShowProgress;
      } else {
        this.progress = `width:20%`;
        clearInterval(this.progressObj);
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
.main_table_wrap {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 10px;
  .trip_line {
    border-top: 1px solid #2dbb55;
    display: inline-block;
    color: #999999;
    font-size: 14px;
    .trip_box {
      .trip_span {
        display: inline-block;
        padding: 8px 18px;
        border-left: 1px solid #eeeeee;
        border-right: 1px solid #eeeeee;
        margin: 0px -1px -1px 0px;

        .trip_number {
          border: 1px solid #cccccc;
          border-radius: 50%;
          display: inline-block;
          padding: 0px 5px;
          font-size: 12px;
          position: relative;
          top: -1px;
        }
      }

      .trip_checked {
        color: #ffffff;
        background: #2dbb55;
        border-left: 1px solid #2dbb55;
        border-right: 1px solid #2dbb55;
        margin: 0px -1px -1px 0px;
        .trip_number {
          border: 1px solid #ffffff;
        }
      }
      .arrow_icon {
        width: 14px;
        position: relative;
        top: -3px;
      }
    }
  }
  // .data_progress {
  //   border: 1px solid #eeeeee;
  //   margin: 10px 0px;
  //   line-height: 30px;
  //   padding-left: 15px;
  //   font-size: 12px;
  // }
  .bar_progress {
    height: 30px;
    width: 100%;
    background: #fff;
    margin: 4px 0px;
    resize: none;
    outline: 0;
    font-size: inherit;
    .flight_process_bar {
      height: 30px;
      background: #32c45d 100%;
      overflow: hidden;

      p {
        line-height: 30px;
        margin-left: 9px;
        color: #fff;
        font-size: 12px;
        width: 90px;
        float: left;
      }
      .flight_icon {
        width: 24px;
        height: 24px;
        float: right;
        margin: 5px 10px;
        background: url("~@/assets/img/flight_progress.png");
        background-size: 24px 24px;
      }
    }
  }
  .f_table_title {
    border: 1px solid #eeeeee;
    line-height: 33px;
    font-size: 12px;
    .title {
      float: left;
      .sort_icon {
        display: inline-block;
        padding-left: 5px;

        img {
          width: 7px;
        }
      }
    }
    .cursor_pointer {
      cursor: pointer;
    }
    .first {
      width: 30%;
      text-indent: 50px;
    }
    .second {
      width: 10%;
      text-align: right;
    }
    .third {
      width: 15%;
      color: #fff;
    }
    .forth {
      width: 15%;
    }
    .five {
      width: 15%;
      text-align: right;
    }
    .six {
      width: 10%;
      color: #fff;
      float: right;
    }
  }
}
</style>
